import { useIntl } from 'react-intl';
import { useAuth } from 'react-oidc-context';

import smallLogo from '../../../../assets/logo/logo.svg';
import { useBalance } from '../../../account/hooks/use-balance';
import { useWalletTotals } from '../../../account/hooks/use-wallet-totals';
import { ContextLink } from '../../../shared/components/context-link/context-link';
import { Icon } from '../../../shared/components/icon/icon';
import { ImageLogo } from '../../../shared/components/image-logo/image-logo.';
import { useCurrentCurrency } from '../../../shared/hooks/use-current-currency';
//import { useTotalBalance } from '../../../shared/hooks/use-total-balance';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import type { FCWithChildren } from '../../../shared/utils/component.interface';
import { AccountActions } from '../account-actions/account-actions';

import styles from './top-navigation.module.scss';

const style = createStyleHelper(styles, 'top-navigation');

export interface ITopNavigationProps {
    className?: string;
    onToggleMenu?: () => void;
    showCloseButton?: boolean;
    showSearch?: boolean;
    onClose?: () => void;
}

export const TopNavigation: FCWithChildren<ITopNavigationProps> = ({ className, onToggleMenu }) => {
    const { wallets } = useBalance();
    const auth = useAuth();
    const selectedCurrency = useCurrentCurrency();
    const totalBalance = useWalletTotals(wallets); //useTotalBalance();
    const intl = useIntl();

    return (
        <nav className={createClassName([className, style()])}>
            <ContextLink className={style('link')} to={'/'}>
                <ImageLogo className={style('logo')} srcPath={smallLogo} />
            </ContextLink>

            {!auth.isAuthenticated && !auth?.user ? (
                <AccountActions />
            ) : (
                <div className={style('user-menu')}>
                    <div className={style('item', { balance: true })} onClick={onToggleMenu}>
                        <span className={style('details')}>
                            {typeof totalBalance !== 'undefined'
                                ? intl.formatNumber(totalBalance.total.value, {
                                      style: 'currency',
                                      currency: selectedCurrency,
                                  })
                                : ''}
                        </span>
                    </div>
                    <div className={style('item', { profile: true })}>
                        <button className={style('icon-button')} onClick={onToggleMenu}>
                            <Icon name={'user-circle'} />
                        </button>
                    </div>
                </div>
            )}
        </nav>
    );
};
